import '@/styles/main.css'
import { UniverseApp } from '@/app/UniverseApp'

const root = document.getElementById('universe-root')
if (root === null) {
  throw new Error('The QuickCasa Universe could not find its #universe-root mount point.')
}

const app = new UniverseApp(root)
void app.start()
